(function () {
  'use strict';
  if (window.ecEtaInitialized) return;
  window.ecEtaInitialized = true;
  const holidays=new Set(['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26']);
  const iso = date => date.toISOString().slice(0, 10);
  function todayUK() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const values = Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    return new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
  }
  function add(start, count, mode) {
    const result = new Date(start);
    let added = 0;
    while (added < count) {
      result.setUTCDate(result.getUTCDate() + 1);
      const weekday = result.getUTCDay();
      if (mode === 'calendar' || (weekday !== 0 && weekday !== 6 && !holidays.has(iso(result)))) added++;
    }
    return result;
  }
  const long = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric' });
  const month = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', month: 'long', year: 'numeric' });
  function range(a, b) {
    return a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()
      ? a.getUTCDate() + '–' + b.getUTCDate() + ' ' + month.format(b)
      : long.format(a) + ' – ' + long.format(b);
  }
  function render(node) {
    node.hidden = true;
    const min = Number(node.dataset.ecEtaMin);
    const max = Number(node.dataset.ecEtaMax);
    const mode = node.dataset.ecEtaMode;
    const checked = node.dataset.ecEtaChecked || '';
    const output = node.querySelector('[data-ec-eta-output]');
    const button = node.closest('.product-info')?.querySelector('[data-add-to-cart]');
    const sourcePreview = node.dataset.ecEtaStatus === 'SOURCE_ESTIMATE' && node.dataset.ecEtaPreview === 'true';
    const listingEstimate = node.dataset.ecEtaStatus === 'LISTING_ESTIMATE';
    const statusAllowed = node.dataset.ecEtaStatus === 'VERIFIED' || node.dataset.ecEtaStatus === 'OWNER_CONFIRMED' || sourcePreview || listingEstimate;
    if (!statusAllowed || button?.disabled || !output ||
        !Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < min || max > 90 ||
        !['calendar', 'business'].includes(mode)) return;
    const today = todayUK();
    // The displayed date window is calculated from an observed UK supplier listing,
    // not a live supplier feed. Hide it if the evidence has become stale.
    if (!/^\d{4}-\d{2}-\d{2}$/.test(checked)) return;
    const checkedDate = new Date(checked + 'T12:00:00Z');
    if (!Number.isFinite(checkedDate.getTime()) || iso(checkedDate) !== checked) return;
    const age = Math.floor((today - checkedDate) / 86400000);
    if (age < 0 || age > (listingEstimate ? 14 : 30)) return;
    const first = add(today, min, mode);
    const last = add(today, max, mode);
    if (mode === 'business' && (today.getUTCFullYear() < 2026 || last.getUTCFullYear() > 2028)) return;
    output.textContent = (node.dataset.ecEtaPrefix || (sourcePreview ? 'Supplier listing estimate' : 'Estimated delivery')) + ': ' + range(first, last);
    node.hidden = false;
  }
  function update() { document.querySelectorAll('.ec-eta').forEach(render); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('change', () => setTimeout(update, 0));
  setInterval(() => { if (!document.hidden) update(); }, 60000);
})();
